<template>
  <div>
    <md-progress-bar md-mode="query" class="md-accent" v-if="loadingSubscriptions"></md-progress-bar>
    <div class="md-layout-item md-size-100" v-else>
      <md-table md-card v-if="subscriptions.length > 0">
        <md-table-row>
          <md-table-head>{{$t('ticket.list.description')}}</md-table-head>
          <md-table-head>{{$t('ticket.list.team')}}</md-table-head>
          <md-table-head>{{$t('ticket.list.size')}}</md-table-head>
          <md-table-head>{{$t('ticket.list.used')}}</md-table-head>
          <md-table-head>{{$t('ticket.list.dueDate')}}</md-table-head>
          <!-- <md-table-head>{{$t('ticket.list.createUser')}}</md-table-head> -->
          <md-table-head>{{$t('ticket.list.actions')}}</md-table-head>
        </md-table-row>

        <md-table-row v-for="subscription in subscriptions" :key="subscription.id">
          <md-table-cell>{{subscription.description}}</md-table-cell>
          <md-table-cell>{{subscription.team}}</md-table-cell>
          <md-table-cell>{{subscription.size}}</md-table-cell>
          <md-table-cell>{{subscription.used}}</md-table-cell>
          <md-table-cell>{{formatDate(subscription.dueDate)}}</md-table-cell>
          <!-- <md-table-cell>
            {{subscription.createUser}}
            <md-tooltip md-direction="bottom">
              <strong>{{$t("ticket.list.createDate")}}</strong><br>
              {{formatDate(subscription.createDate)}}
            </md-tooltip>
          </md-table-cell> -->
          <md-table-cell>
            <md-button class="md-info" :to="`/ticketera/detail/subscriptions/${subscription.id}`">
              {{$t('ticket.list.detail')}}
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <md-empty-state
        v-else
        md-icon="local_activity"
        md-label="Sin subscripciones generados"
        md-description="">
      </md-empty-state>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      loadingSubscriptions: true
    }
  },
  computed: {
    ...mapState({
      subscriptions: state => state.TicketModule.subscriptions
    })
  },
  async mounted() {
    await this.$store.dispatch("subscriptionLotGet")
    this.loadingSubscriptions = false
  },
  methods: {
    formatDate(date) {
      if (date == null) return; 
      return moment(date).format("DD/MM/YYYY HH:mm")
    }
  }
}
</script>